module.exports = __webpack_public_path__ + "static/media/three.84e7c6ae.svg";